<div class="address">
    <ng-content></ng-content>
    <a class="address"
       [attr.aria-label]="'FOOTER.DIRECTION_TO' | translate: { store:(menu?.store?.name || menu?.store?.pageTitle)}"
       [href]="menu?.store?.address | googleMapLink"
       target="_blank">
        {{menu?.store?.address}}
    </a>
    <br>
    <a class="phone"
       [href]="'tel:'+menu?.store?.phone">{{ 'FOOTER.TELEFON' | translate: { phone:menu?.store?.phone } }}</a>
    <!-- <a class="email"
       [attr.aria-label]="'email '+(menu?.store?.name || menu?.store?.pageTitle)"
       [href]="'mailto:'+menu?.store?.email">{{ menu?.store?.email }}</a> -->
</div>
